import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader, StatusChip, LoadingBlock } from "@/components/Common";
import { Card, CardContent } from "@/components/ui/card";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { fmtCurrency } from "@/lib/utils-app";

const STATUSES = ["clean", "dirty", "cleaning", "inspected", "occupied", "out_of_order"];

export default function Rooms() {
    const [rooms, setRooms] = useState(null);
    const [filter, setFilter] = useState("all");

    const load = () => api.get("/rooms").then((r) => setRooms(r.data));
    useEffect(() => {
        load();
    }, []);

    const change = async (id, status) => {
        await api.patch(`/rooms/${id}`, { status });
        toast.success(`Room status updated to ${status}`);
        load();
    };

    if (!rooms) return <LoadingBlock rows={6} />;
    const filtered = filter === "all" ? rooms : rooms.filter((r) => r.status === filter);

    return (
        <>
            <PageHeader
                title="Rooms"
                subtitle={`${rooms.length} rooms across the property.`}
                actions={
                    <Select value={filter} onValueChange={setFilter}>
                        <SelectTrigger className="w-44" data-testid="rooms-status-filter">
                            <SelectValue placeholder="All statuses" />
                        </SelectTrigger>
                        <SelectContent>
                            <SelectItem value="all">All statuses</SelectItem>
                            {STATUSES.map((s) => (
                                <SelectItem key={s} value={s} className="capitalize">
                                    {s.replace("_", " ")}
                                </SelectItem>
                            ))}
                        </SelectContent>
                    </Select>
                }
            />
            <Card>
                <CardContent className="p-0">
                    <div className="overflow-x-auto">
                        <table className="w-full text-sm" data-testid="rooms-table">
                            <thead className="bg-secondary text-xs uppercase tracking-wider text-muted-foreground">
                                <tr>
                                    <th className="text-left py-2.5 px-4">Room</th>
                                    <th className="text-left py-2.5 px-4">Floor</th>
                                    <th className="text-left py-2.5 px-4">Type</th>
                                    <th className="text-left py-2.5 px-4">Bed</th>
                                    <th className="text-left py-2.5 px-4">Capacity</th>
                                    <th className="text-left py-2.5 px-4">Rate</th>
                                    <th className="text-left py-2.5 px-4">Status</th>
                                    <th className="text-left py-2.5 px-4">Change status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filtered.map((r) => (
                                    <tr key={r.id} className="border-t border-border hover:bg-secondary/50" data-testid="rooms-row">
                                        <td className="py-2.5 px-4 font-medium">{r.number}</td>
                                        <td className="py-2.5 px-4">{r.floor}</td>
                                        <td className="py-2.5 px-4">{r.type}</td>
                                        <td className="py-2.5 px-4 capitalize">{r.bed_config}</td>
                                        <td className="py-2.5 px-4">{r.capacity}</td>
                                        <td className="py-2.5 px-4 tabular">{fmtCurrency(r.rate)}</td>
                                        <td className="py-2.5 px-4">
                                            <StatusChip status={r.status} />
                                        </td>
                                        <td className="py-2.5 px-4">
                                            <Select value={r.status} onValueChange={(v) => change(r.id, v)}>
                                                <SelectTrigger className="h-8 w-36" data-testid="rooms-status-set">
                                                    <SelectValue />
                                                </SelectTrigger>
                                                <SelectContent>
                                                    {STATUSES.map((s) => (
                                                        <SelectItem key={s} value={s} className="capitalize">
                                                            {s.replace("_", " ")}
                                                        </SelectItem>
                                                    ))}
                                                </SelectContent>
                                            </Select>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </CardContent>
            </Card>
        </>
    );
}
